import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zendeskSell = defineConnector({
  identifier: "zendeskSell",
  name: "Zendesk Sell",
  tagLine: "Sales CRM",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.getbase\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Zendesk Sell app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Zendesk Sell authentication docs](https://developer.zendesk.com/api-reference/sales-crm/introduction/#authentication) and create an OAuth client for your Zendesk Sell account. Copy the client ID and client secret from the app settings.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/zendeskSell/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Zendesk Sell account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Zendesk Sell account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.getbase.com/oauth2/authorize",
    tokenEndpoint: () => "https://api.getbase.com/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.getbase.com/",
  },
});
